import { jwtDecode } from 'jwt-decode';
import tokenStore from '../utils/tokenStore';

const decodedJWT = (tokenInput) => {
    // Only use in-memory token or explicit param to avoid stale localStorage tokens
    const token = tokenStore.getToken() || tokenInput;

    if (!token || typeof token !== 'string') {
        return null;
    }

    try {
        const decoded = jwtDecode(token);
        // backend sign: { id, username, role, linkKey }
        return {
            id: decoded.id,
            username: decoded.username,
            role: decoded.role,
            linkKey: decoded.linkKey,
        };
    } catch (error) {
        return null;
    }
};

export default decodedJWT;
